import React, { NamedExoticComponent, useEffect, useRef, useState } from 'react';
import { Box, Button, Divider, Flex, VStack, Text, CloseIcon, Pressable, NativeBaseProvider } from 'native-base';
import { dispatch } from '@store';
import { OfferDisclosures } from 'shared-ui-components';
import { setESIGNPOPUPSTATUS, setParentModal } from '@store/actions/lip.action';
import { logUserEvent, getAdditionalProperties } from 'fmc-digital-common';
import { selectSelctedDisclosureUser } from '@store/selectors/lip.selector';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectLoanNumberSelected, selectSelectedLoanNumber } from '@store/selectors/widgets.selectors';
import { ButtonBase, StackBase, TypographyBase } from '@fmc-digital/ui';
import { useMediaQuery, useTheme } from '@mui/material';
import { NEW_LOAN_IN_PROGRESS_WIDGETS } from '@utils/appConstants';

const ComponentMap: Record<string, NamedExoticComponent<any>> = {
    OfferDisclosures: OfferDisclosures
};

//TODO - add these after reskin LIP
{
    /*After signing your disclosures, click &ldquo;CLOSE&rdquo; to go back to your dashboard.*/
}
{
    /*CLOSE*/
}

const FullScreenModal = ({ payload, component, ...rest }: any) => {
    const navigate = useNavigate();
    const selctedDisclosureUser = useSelector(selectSelctedDisclosureUser);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    //@ts-ignore
    const loanNumber = getAdditionalProperties('amplify')?.loanNumber;

    useEffect(() => {
        window.addEventListener('message', event => {
            if (payload?.url?.includes(event.origin) && event.data.type == 'signOutClick') {
                dispatch(setParentModal({ showModal: false, payload: undefined, component: undefined }));
                setTimeout(() => {
                    dispatch(setESIGNPOPUPSTATUS('closed'));
                }, 500);
                navigate(`/new-loan/${loanNumber}`, { state: NEW_LOAN_IN_PROGRESS_WIDGETS });
            }
        });
    }, [payload?.url]);
    const eSignRef = useRef(null);
    useEffect(() => {
        setTimeout(() => {
            if (eSignRef && eSignRef.current && payload.token) eSignRef.current.submit();
        }, 500);
    }, []);

    // // @ts-ignore
    const Component = ComponentMap[component];
    const [props, setProps] = useState<any>();

    useEffect(() => {
        if (component === 'OfferDisclosures') {
            setProps({
                disclosureType: payload
            });
        }
    }, []);

    const closeModal = () => {
        logUserEvent({
            action: 'SaveClicked',
            type: 'LIPSignDisclosurePopUp',
            description: `Sign Disclosure Task Pop-up ${selctedDisclosureUser}`
        });
        dispatch(setParentModal({ showModal: false, payload: undefined, component: undefined }));
        setTimeout(() => {
            dispatch(setESIGNPOPUPSTATUS('closed'));
        }, 500);
        navigate(`/new-loan/${loanNumber}`, { state: NEW_LOAN_IN_PROGRESS_WIDGETS });
    };

    return (
        <NativeBaseProvider>
            <Box bg="white" p={{ base: 0, md: 4, lg: 8 }} w="100%" h="100vh">
                {component === 'esign' && (
                    <>
                        {payload && payload.token ? (
                            <>
                                <form ref={eSignRef} id="eSignForm" action={payload.url} method="POST" target="eSign">
                                    <input type="hidden" name="access_token" value={payload.token} />
                                </form>
                                <iframe
                                    name="eSign"
                                    style={{
                                        flex: 1
                                    }}
                                />
                            </>
                        ) : (
                            payload && payload.url && <iframe src={payload.url} name="eSign" style={{ flex: 1 }} />
                        )}
                        {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
                        {/*@ts-ignore*/}
                        <StackBase
                            sx={{
                                width: '100%',
                                padding: isMobile ? '1rem' : 'rem',
                                justifyContent: 'space-between',
                                alignItems: 'space-between',
                                display: 'flex',
                                gap: '0.5rem',
                                flexDirection: isMobile ? 'column' : 'row'
                            }}
                        >
                            <TypographyBase variant="alt-subtitle1">
                                After signing your disclosures, click &rdquo;CLOSE&rdquo; to go back to your dashboard.
                            </TypographyBase>
                            <ButtonBase
                                onClick={closeModal}
                                variant="contained"
                                sx={{
                                    borderRadius: '6.25rem',
                                    padding: '1rem 2rem !important'
                                }}
                            >
                                Close
                            </ButtonBase>
                        </StackBase>
                        {/* <VStack space="1" mt="4" testID="esign_test_id">
                            <Divider orientation="horizontal" bg="#0a4a8d" opacity="30" />
                            <Flex direction="row" justify="space-between" m="2" p={{ base: 2, md: undefined, lg: undefined }}>
                                <VStack space="2" width="80%">
                                    <TypographyBase variant="alt-subtitle1">
                                        After signing your disclosures, click &rdquo;CLOSE&rdquo; to go back to your dashboard.
                                    </TypographyBase>
                                </VStack>
                                <ButtonBase
                                    onClick={closeModal}
                                    variant="contained"
                                    sx={{
                                        borderRadius: '6.25rem'
                                    }}
                                >
                                    Save
                                </ButtonBase>
                            </Flex>
                        </VStack> */}
                    </>
                )}
                {Component && (
                    <>
                        <Box alignSelf="flex-end" mb={'10'}>
                            {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
                            {/*@ts-ignore*/}
                            <Pressable onPress={closeModal}>
                                <CloseIcon color="#222A34" id="closeBtn" data-testid="closeBtn" size="4" border="3px solid #222A34" />
                            </Pressable>
                        </Box>
                        <Component {...props} />
                    </>
                )}
            </Box>
        </NativeBaseProvider>
    );
};

export default React.memo(FullScreenModal);
